export type OsanoTrackingOptOutPreloadScriptOptions = {
  cookieDomain?: string;
  failSafeOptOutDays?: number;
};

export function getOsanoTrackingOptOutPreloadScript(
  options: OsanoTrackingOptOutPreloadScriptOptions = {},
): string {
  const { cookieDomain, failSafeOptOutDays = 1 } = options;

  const domainPart = cookieDomain ? `; domain=${cookieDomain}` : '';

  return `
(function (w, o, d) {
  w[o] =
    w[o] ||
    function () {
      w[o][d].push(arguments);
    };
  w[o][d] = w[o][d] || [];
})(window, 'Osano', 'data');

function getUtcDateDaysFromNow(days) {
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  return date.toUTCString();
}

function setTrackingOptOutCookie(days) {
  document.cookie =
    'trackingOptOut=true; expires=' +
    getUtcDateDaysFromNow(days) +
    '${domainPart}; path=/';
}

function clearTrackingOptOutCookie() {
  document.cookie =
    'trackingOptOut=true; expires=Thu, 01 Jan 1970 00:00:01 GMT' +
    '${domainPart}; path=/';
}

function handleCookieConsent(consent) {
  var hasNotConsentedToMarketing = consent && consent.MARKETING === 'DENY';
  var hasOptedOutOfAllNonEssential = consent && consent.OPT_OUT === 'ACCEPT';

  if (hasNotConsentedToMarketing || hasOptedOutOfAllNonEssential) {
    setTrackingOptOutCookie(365);
  } else {
    clearTrackingOptOutCookie();
  }
}

window.Osano('onConsentSaved', function (consent) {
  try {
    handleCookieConsent(consent);
  } catch (e) {
    // Fail safe: if Osano (or our handler) errors, opt out temporarily by default.
    setTrackingOptOutCookie(${failSafeOptOutDays});
  }
});

// Track default consent state on initial pageload to ensure tracking is blocked for opt-out-by-default jurisdictions.
window.Osano('onInitialized', function () {
  try {
    var consent =
      window.Osano &&
      window.Osano.cm &&
      typeof window.Osano.cm.getConsent === 'function'
        ? window.Osano.cm.getConsent()
        : null;

    if (consent) {
      handleCookieConsent(consent);
    } else {
      setTrackingOptOutCookie(${failSafeOptOutDays});
    }
  } catch (e) {
    // Fail safe: if Osano errors, opt out temporarily by default.
    setTrackingOptOutCookie(${failSafeOptOutDays});
  }
});
`.trim();
}
